<app-header [transparent]="transparent" />
<div class="advisory">
  <ng-container *ngFor="let heading of head">
    <div class="text-center inline_padding1 bg_img advisory_top" *ngIf="heading.page === currentPage">
      <div>
        <span class="text_style_5">Advisory Panel</span>
      </div>
      <div class="p-top-16">
        <span class="text_black_4_res" [innerHtml]="heading.page_sub_heading"></span>
      </div>
    </div>
  </ng-container>

  <div class="advisory_body bg_1 p-b-60">
    <ng-container *ngFor="let panel of panelList">
      <div class="advisory_body_card card_3">
        <div class="card_3_top p-top-16 advisory_body_card_body">
          <div class="card_3_top_image">
            <img class="card_3_top_image_pic" [src]="getPanelImageUrl(panel.image)" alt="profile" />
            <div class="dis-flex advisory_body_card_body_bottom_box p-top-16 p-bot-16" style="
                background-color: white;
                justify-content: center;
                align-items: center;
                width: auto;
              ">
              <div class="advisory_body_card_body_bottom_box_icon" *ngIf="panel.social.facebook">
                <a [href]="panel.social.facebook" target="_blank">
                  <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.34107 12.418C3.25754 12.418 1.41995 12.418 0.584687 12.418C0.139211 12.418 0 12.2528 0 11.8398C0 10.7384 0 9.60951 0 8.50813C0 8.06758 0.167053 7.92991 0.584687 7.92991H3.34107C3.34107 7.84731 3.34107 6.25031 3.34107 5.50688C3.34107 4.40551 3.53596 3.3592 4.09281 2.39549C4.67749 1.40425 5.51276 0.743429 6.57077 0.357947C7.26682 0.110137 7.96288 0 8.71462 0H11.4432C11.8329 0 12 0.165207 12 0.550688V3.68961C12 4.07509 11.8329 4.2403 11.4432 4.2403C10.6914 4.2403 9.93968 4.2403 9.18794 4.26783C8.4362 4.26783 8.0464 4.62578 8.0464 5.39675C8.01856 6.22278 8.0464 7.02128 8.0464 7.87484H11.2761C11.7216 7.87484 11.8886 8.04005 11.8886 8.4806V11.8123C11.8886 12.2528 11.7494 12.3905 11.2761 12.3905C10.2738 12.3905 8.12993 12.3905 8.0464 12.3905V21.3667C8.0464 21.8348 7.90719 22 7.40603 22C6.23666 22 5.09513 22 3.92575 22C3.50812 22 3.34107 21.8348 3.34107 21.4218C3.34107 18.5307 3.34107 12.5006 3.34107 12.418Z"
                      fill="#0866ff" />
                  </svg>
                </a>
              </div>
              <div class="advisory_body_card_body_bottom_box_icon" *ngIf="panel.social.x">
                <a [href]="panel.social.x" target="_blank">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.9027 8.46864L19.3482 0H17.5838L11.119 7.3532L5.95547 0H0L7.8082 11.1193L0 20H1.76443L8.59152 12.2348L14.0445 20H20L11.9023 8.46864H11.9027ZM9.48608 11.2173L8.69495 10.1101L2.40018 1.29967H5.11025L10.1902 8.40994L10.9813 9.51718L17.5847 18.7594H14.8746L9.48608 11.2177V11.2173Z"
                      fill="#303030" />
                  </svg>
                </a>
              </div>
              <div class="advisory_body_card_body_bottom_box_icon" *ngIf="panel.social.linkdin">
                <a [href]="panel.social.linkdin" target="_blank">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.4992 20.5V13.175C20.4992 9.57495 19.7242 6.82495 15.5242 6.82495C13.4992 6.82495 12.1492 7.92495 11.5992 8.97495H11.5492V7.14995H7.57422V20.5H11.7242V13.875C11.7242 12.125 12.0492 10.45 14.1992 10.45C16.3242 10.45 16.3492 12.425 16.3492 13.975V20.475H20.4992V20.5Z"
                      fill="#0077b5" />
                    <path d="M0.824219 7.1499H4.97422V20.4999H0.824219V7.1499Z" fill="#0077b5" />
                    <path
                      d="M2.9 0.5C1.575 0.5 0.5 1.575 0.5 2.9C0.5 4.225 1.575 5.325 2.9 5.325C4.225 5.325 5.3 4.225 5.3 2.9C5.3 1.575 4.225 0.5 2.9 0.5Z"
                      fill="#0077b5" />
                  </svg>
                </a>
              </div>
              <div class="advisory_body_card_body_bottom_box_icon" *ngIf="panel.social.instagram">
                <a [href]="panel.social.instagram" target="_blank">
                  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_619_17531)">
                      <path
                        d="M21.9789 5.88005C21.9274 4.81738 21.7383 4.0868 21.4675 3.45374C21.1882 2.78176 20.7584 2.18014 20.1953 1.68002C19.6452 1.1721 18.9791 0.777435 18.2484 0.527447C17.5481 0.281274 16.7486 0.109427 15.5797 0.0625732C14.402 0.0117516 14.0281 0 11.0412 0C8.0543 0 7.68043 0.0117516 6.50712 0.0586052C5.33818 0.105459 4.53454 0.277459 3.83834 0.523479C3.099 0.777435 2.43722 1.16814 1.88708 1.68002C1.32838 2.18014 0.894408 2.78573 0.619254 3.44992C0.348464 4.0868 0.159432 4.81341 0.107893 5.87609C0.0519892 6.9467 0.0390625 7.28658 0.0390625 10.002C0.0390625 12.7173 0.0519892 13.0572 0.103528 14.1239C0.155067 15.1865 0.344267 15.9171 0.615057 16.5502C0.894408 17.2221 1.32838 17.8238 1.88708 18.3239C2.43722 18.8318 3.10337 19.2265 3.83398 19.4765C4.53454 19.7226 5.33381 19.8945 6.50293 19.9413C7.67607 19.9883 8.0501 19.9999 11.037 19.9999C14.0239 19.9999 14.3978 19.9883 15.5711 19.9413C16.7401 19.8945 17.5437 19.7226 18.2399 19.4765C19.7184 18.9568 20.8873 17.8941 21.459 16.5502C21.7296 15.9133 21.9188 15.1865 21.9703 14.1239C22.0219 13.0572 22.0348 12.7173 22.0348 10.002C22.0348 7.28658 22.0304 6.9467 21.9789 5.88005ZM19.9978 14.0457C19.9504 15.0225 19.7699 15.5499 19.6195 15.9015C19.2498 16.7728 18.4892 17.4643 17.5308 17.8004C17.144 17.9372 16.5596 18.1012 15.4893 18.1441C14.329 18.1911 13.981 18.2027 11.0456 18.2027C8.1102 18.2027 7.75783 18.1911 6.60164 18.1441C5.52721 18.1012 4.94702 17.9372 4.56023 17.8004C4.08328 17.6402 3.64914 17.3862 3.29676 17.0541C2.93146 16.7298 2.65211 16.3391 2.47583 15.9055C2.32541 15.5539 2.14494 15.0225 2.09777 14.0497C2.04606 12.9948 2.0333 12.6783 2.0333 10.0097C2.0333 7.34122 2.04606 7.02087 2.09777 5.96995C2.14494 4.99319 2.32541 4.46575 2.47583 4.11412C2.65211 3.68038 2.93146 3.28586 3.30113 2.96536C3.65771 2.63327 4.08748 2.37931 4.56459 2.21921C4.95138 2.08247 5.53594 1.9184 6.606 1.87537C7.76639 1.82851 8.11457 1.81676 11.0498 1.81676C13.9895 1.81676 14.3375 1.82851 15.4937 1.87537C16.5681 1.9184 17.1483 2.08247 17.5351 2.21921C18.0121 2.37931 18.4462 2.63327 18.7986 2.96536C19.1639 3.28967 19.4432 3.68038 19.6195 4.11412C19.7699 4.46575 19.9504 4.99701 19.9978 5.96995C20.0493 7.02484 20.0622 7.34122 20.0622 10.0097C20.0622 12.6783 20.0493 12.9908 19.9978 14.0457Z"
                        fill=" #962fbf" />
                      <path
                        d="M11.0421 4.86426C7.92208 4.86426 5.39062 7.16543 5.39062 10.002C5.39062 12.8385 7.92208 15.1397 11.0421 15.1397C14.1623 15.1397 16.6936 12.8385 16.6936 10.002C16.6936 7.16543 14.1623 4.86426 11.0421 4.86426ZM11.0421 13.3347C9.018 13.3347 7.37614 11.8422 7.37614 10.002C7.37614 8.16172 9.018 6.66927 11.0421 6.66927C13.0664 6.66927 14.7081 8.16172 14.7081 10.002C14.7081 11.8422 13.0664 13.3347 11.0421 13.3347Z"
                        fill="#962fbf" />
                      <path
                        d="M18.2326 4.66109C18.2326 5.32345 17.6419 5.86051 16.9131 5.86051C16.1845 5.86051 15.5938 5.32345 15.5938 4.66109C15.5938 3.99858 16.1845 3.46167 16.9131 3.46167C17.6419 3.46167 18.2326 3.99858 18.2326 4.66109Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_619_17531">
                        <rect width="22" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
              <div class="advisory_body_card_body_bottom_box_icon" *ngIf="panel.social.google_scholar">
                <a [href]="panel.social.google_scholar" class="text_decoration_none" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88" width="22" height="20">
                    <g>
                      <polygon class="st3" points="61.44,98.67 0,48.64 61.44,0 61.44,98.67" fill="#4086f4" />
                      <polygon class="st0" points="61.44,98.67 122.88,48.64 61.44,0 61.44,98.67" fill="#326ac4" />
                      <path class="st1"
                        d="M97.28,87.04c0-19.79-16.05-35.84-35.84-35.84c-19.79,0-35.84,16.05-35.84,35.84s16.05,35.84,35.84,35.84 C81.23,122.88,97.28,106.83,97.28,87.04L97.28,87.04z"
                        fill="#77a9fa" />
                      <path class="st2"
                        d="M29.05,71.68C34.8,59.57,47.14,51.2,61.44,51.2c14.3,0,26.64,8.37,32.39,20.48H29.05L29.05,71.68z"
                        fill="#a1c4ff" />
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="card_3_top_info advisory_body_card_body_bottom">
            <div>
              <div class="text_black_7" [innerHtml]="panel.name"></div>
              <div class="p-top-16 text_black_4_res text_align-justify" [innerHtml]="panel.description"></div>
              <div class="p-top-24 text_black_1_res" *ngIf="panel.bio">
                Biography
              </div>
              <div class="p-top-16 text_black_3_res text_align-justify" [innerHtml]="panel.bio"></div>
              <!-- <div class="p-top-16" *ngIf="panel.web_link">
                <span class="text_black_10">Weblink: </span>
                <a [href]="panel.web_link" class="text_blue_14" target="_blank">
                    {{ panel.web_link }}
                </a>
            </div> -->
              <div *ngIf="panel.web_link" class="p-top-12">
                <button type="button" class="rounded-pill text_white_1 button_blue_7"
                  (click)="openLink(panel.web_link)">
                  <span class="button_blue_1_text"> Weblink</span>
                  <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" />
                </button>
              </div>
              <div class="dis-flex advisory_body_card_body_bottom_box p-top-16 p-bot-16">
                <!-- <div
                  class="advisory_body_card_body_bottom_box_icon"
                  *ngIf="panel.social.facebook"
                >
                  <a [href]="panel.social.facebook" target="_blank">
                    <svg
                      width="12"
                      height="22"
                      viewBox="0 0 12 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.34107 12.418C3.25754 12.418 1.41995 12.418 0.584687 12.418C0.139211 12.418 0 12.2528 0 11.8398C0 10.7384 0 9.60951 0 8.50813C0 8.06758 0.167053 7.92991 0.584687 7.92991H3.34107C3.34107 7.84731 3.34107 6.25031 3.34107 5.50688C3.34107 4.40551 3.53596 3.3592 4.09281 2.39549C4.67749 1.40425 5.51276 0.743429 6.57077 0.357947C7.26682 0.110137 7.96288 0 8.71462 0H11.4432C11.8329 0 12 0.165207 12 0.550688V3.68961C12 4.07509 11.8329 4.2403 11.4432 4.2403C10.6914 4.2403 9.93968 4.2403 9.18794 4.26783C8.4362 4.26783 8.0464 4.62578 8.0464 5.39675C8.01856 6.22278 8.0464 7.02128 8.0464 7.87484H11.2761C11.7216 7.87484 11.8886 8.04005 11.8886 8.4806V11.8123C11.8886 12.2528 11.7494 12.3905 11.2761 12.3905C10.2738 12.3905 8.12993 12.3905 8.0464 12.3905V21.3667C8.0464 21.8348 7.90719 22 7.40603 22C6.23666 22 5.09513 22 3.92575 22C3.50812 22 3.34107 21.8348 3.34107 21.4218C3.34107 18.5307 3.34107 12.5006 3.34107 12.418Z"
                        fill="#303030"
                      />
                    </svg>
                  </a>
                </div>
                <div
                  class="advisory_body_card_body_bottom_box_icon"
                  *ngIf="panel.social.x"
                >
                  <a [href]="panel.social.x" target="_blank">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9027 8.46864L19.3482 0H17.5838L11.119 7.3532L5.95547 0H0L7.8082 11.1193L0 20H1.76443L8.59152 12.2348L14.0445 20H20L11.9023 8.46864H11.9027ZM9.48608 11.2173L8.69495 10.1101L2.40018 1.29967H5.11025L10.1902 8.40994L10.9813 9.51718L17.5847 18.7594H14.8746L9.48608 11.2177V11.2173Z"
                        fill="#303030"
                      />
                    </svg>
                  </a>
                </div>
                <div
                  class="advisory_body_card_body_bottom_box_icon"
                  *ngIf="panel.social.linkdin"
                >
                  <a [href]="panel.social.linkdin" target="_blank">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      
                    >
                      <path
                        d="M20.4992 20.5V13.175C20.4992 9.57495 19.7242 6.82495 15.5242 6.82495C13.4992 6.82495 12.1492 7.92495 11.5992 8.97495H11.5492V7.14995H7.57422V20.5H11.7242V13.875C11.7242 12.125 12.0492 10.45 14.1992 10.45C16.3242 10.45 16.3492 12.425 16.3492 13.975V20.475H20.4992V20.5Z"
                        fill="#0077b5"
                      />
                      <path
                        d="M0.824219 7.1499H4.97422V20.4999H0.824219V7.1499Z"
                        fill="#0077b5"
                      />
                      <path
                        d="M2.9 0.5C1.575 0.5 0.5 1.575 0.5 2.9C0.5 4.225 1.575 5.325 2.9 5.325C4.225 5.325 5.3 4.225 5.3 2.9C5.3 1.575 4.225 0.5 2.9 0.5Z"
                        fill="#0077b5"
                      />
                    </svg>
                  </a>
                </div>
                <div
                  class="advisory_body_card_body_bottom_box_icon"
                  *ngIf="panel.social.instagram"
                >
                  <a [href]="panel.social.instagram" target="_blank">
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_619_17531)">
                        <path
                          d="M21.9789 5.88005C21.9274 4.81738 21.7383 4.0868 21.4675 3.45374C21.1882 2.78176 20.7584 2.18014 20.1953 1.68002C19.6452 1.1721 18.9791 0.777435 18.2484 0.527447C17.5481 0.281274 16.7486 0.109427 15.5797 0.0625732C14.402 0.0117516 14.0281 0 11.0412 0C8.0543 0 7.68043 0.0117516 6.50712 0.0586052C5.33818 0.105459 4.53454 0.277459 3.83834 0.523479C3.099 0.777435 2.43722 1.16814 1.88708 1.68002C1.32838 2.18014 0.894408 2.78573 0.619254 3.44992C0.348464 4.0868 0.159432 4.81341 0.107893 5.87609C0.0519892 6.9467 0.0390625 7.28658 0.0390625 10.002C0.0390625 12.7173 0.0519892 13.0572 0.103528 14.1239C0.155067 15.1865 0.344267 15.9171 0.615057 16.5502C0.894408 17.2221 1.32838 17.8238 1.88708 18.3239C2.43722 18.8318 3.10337 19.2265 3.83398 19.4765C4.53454 19.7226 5.33381 19.8945 6.50293 19.9413C7.67607 19.9883 8.0501 19.9999 11.037 19.9999C14.0239 19.9999 14.3978 19.9883 15.5711 19.9413C16.7401 19.8945 17.5437 19.7226 18.2399 19.4765C19.7184 18.9568 20.8873 17.8941 21.459 16.5502C21.7296 15.9133 21.9188 15.1865 21.9703 14.1239C22.0219 13.0572 22.0348 12.7173 22.0348 10.002C22.0348 7.28658 22.0304 6.9467 21.9789 5.88005ZM19.9978 14.0457C19.9504 15.0225 19.7699 15.5499 19.6195 15.9015C19.2498 16.7728 18.4892 17.4643 17.5308 17.8004C17.144 17.9372 16.5596 18.1012 15.4893 18.1441C14.329 18.1911 13.981 18.2027 11.0456 18.2027C8.1102 18.2027 7.75783 18.1911 6.60164 18.1441C5.52721 18.1012 4.94702 17.9372 4.56023 17.8004C4.08328 17.6402 3.64914 17.3862 3.29676 17.0541C2.93146 16.7298 2.65211 16.3391 2.47583 15.9055C2.32541 15.5539 2.14494 15.0225 2.09777 14.0497C2.04606 12.9948 2.0333 12.6783 2.0333 10.0097C2.0333 7.34122 2.04606 7.02087 2.09777 5.96995C2.14494 4.99319 2.32541 4.46575 2.47583 4.11412C2.65211 3.68038 2.93146 3.28586 3.30113 2.96536C3.65771 2.63327 4.08748 2.37931 4.56459 2.21921C4.95138 2.08247 5.53594 1.9184 6.606 1.87537C7.76639 1.82851 8.11457 1.81676 11.0498 1.81676C13.9895 1.81676 14.3375 1.82851 15.4937 1.87537C16.5681 1.9184 17.1483 2.08247 17.5351 2.21921C18.0121 2.37931 18.4462 2.63327 18.7986 2.96536C19.1639 3.28967 19.4432 3.68038 19.6195 4.11412C19.7699 4.46575 19.9504 4.99701 19.9978 5.96995C20.0493 7.02484 20.0622 7.34122 20.0622 10.0097C20.0622 12.6783 20.0493 12.9908 19.9978 14.0457Z"
                          fill="black"
                        />
                        <path
                          d="M11.0421 4.86426C7.92208 4.86426 5.39062 7.16543 5.39062 10.002C5.39062 12.8385 7.92208 15.1397 11.0421 15.1397C14.1623 15.1397 16.6936 12.8385 16.6936 10.002C16.6936 7.16543 14.1623 4.86426 11.0421 4.86426ZM11.0421 13.3347C9.018 13.3347 7.37614 11.8422 7.37614 10.002C7.37614 8.16172 9.018 6.66927 11.0421 6.66927C13.0664 6.66927 14.7081 8.16172 14.7081 10.002C14.7081 11.8422 13.0664 13.3347 11.0421 13.3347Z"
                          fill="black"
                        />
                        <path
                          d="M18.2326 4.66109C18.2326 5.32345 17.6419 5.86051 16.9131 5.86051C16.1845 5.86051 15.5938 5.32345 15.5938 4.66109C15.5938 3.99858 16.1845 3.46167 16.9131 3.46167C17.6419 3.46167 18.2326 3.99858 18.2326 4.66109Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_619_17531">
                          <rect width="22" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
                <div
                  class="advisory_body_card_body_bottom_box_icon"
                  *ngIf="panel.social.google_scholar"
                >
                  <a
                    [href]="panel.social.google_scholar"
                    class="text_decoration_none"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 122.88 122.88"
                      width="22"
                      height="20"
                    >
                      <style>
                        .st0 {
                          fill: #ffffff;
                          stroke: #000000;
                          stroke-width: 10;
                        }
                        .st1 {
                          fill: #ffffff;
                          stroke: #000000;
                          stroke-width: 10;
                        }
                        .st2 {
                          fill: #ffffff;
                          stroke: #000000;
                          stroke-width: 10;
                        }
                        .st3 {
                          fill: #ffffff;
                          stroke: #000000;
                          stroke-width: 10;
                        }
                      </style>
                      <g>
                        <polygon
                          class="st3"
                          points="61.44,98.67 0,48.64 61.44,0 61.44,98.67"
                        />
                        <polygon
                          class="st0"
                          points="61.44,98.67 122.88,48.64 61.44,0 61.44,98.67"
                        />
                        <path
                          class="st1"
                          d="M97.28,87.04c0-19.79-16.05-35.84-35.84-35.84c-19.79,0-35.84,16.05-35.84,35.84s16.05,35.84,35.84,35.84 C81.23,122.88,97.28,106.83,97.28,87.04L97.28,87.04z"
                        />
                        <path
                          class="st2"
                          d="M29.05,71.68C34.8,59.57,47.14,51.2,61.44,51.2c14.3,0,26.64,8.37,32.39,20.48H29.05L29.05,71.68z"
                        />
                      </g>
                    </svg>
                  </a>
                </div> -->
                <div class="share-buttons" style="margin-top: 15px">
                  <button (click)="copyLink()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fas fa-link" style="color: #000"></i>
                    <!-- Copy Link -->
                  </button>
                  <button (click)="shareViaEmail()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fas fa-envelope" style="color: #ea4335"></i>
                    <!-- Email -->
                  </button>
                  <button (click)="shareViaSMS()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fas fa-sms" style="color: #25d366"></i>
                    <!-- SMS -->
                  </button>
                  <button (click)="shareViaWhatsApp()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-whatsapp" style="color: #25d366"></i>
                    <!-- WhatsApp -->
                  </button>
                  <button (click)="shareViaMessenger()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-facebook-messenger" style="color: #0084ff"></i>
                    <!-- Messenger -->
                  </button>
                  <button (click)="shareViaViber()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-viber" style="color: #59267c"></i>
                    <!-- Viber -->
                  </button>
                  <button (click)="shareViaFacebook()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-facebook" style="color: #4267b2"></i>
                    <!-- Facebook -->
                  </button>
                  <button (click)="shareViaTwitter()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-twitter" style="color: #1da1f2"></i>
                    <!-- Twitter -->
                  </button>
                  <button (click)="shareViaLinkedIn()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-linkedin" style="color: #0077b5"></i>
                    <!-- LinkedIn -->
                  </button>
                  <button (click)="shareViaPinterest()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-pinterest" style="color: #e60023"></i>
                    <!-- Pinterest -->
                  </button>
                  <button (click)="shareViaReddit()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-reddit" style="color: #ff4500"></i>
                    <!-- Reddit -->
                  </button>
                  <button (click)="shareViaTumblr()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-tumblr" style="color: #35465c"></i>
                    <!-- Tumblr -->
                  </button>
                  <button (click)="shareViaTelegram()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-telegram" style="color: #0088cc"></i>
                    <!-- Telegram -->
                  </button>
                  <button (click)="shareViaVK()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-vk" style="color: #4b7be5"></i>
                    <!-- VK -->
                  </button>
                  <button (click)="shareViaMix()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-mix" style="color: #00a3e0"></i>
                    <!-- Mix -->
                  </button>
                  <button (click)="shareViaXing()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-xing" style="color: #006567"></i>
                    <!-- Xing -->
                  </button>
                  <button (click)="shareViaLine()" style="
                      background: transparent;
                      border: none;
                      cursor: pointer;
                    ">
                    <i class="fab fa-line" style="color: #00b900"></i>
                    <!-- Line -->
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="advisory_body_card_footer bg_2 p-b-80" style="height: 650px">
          <div class="text-center p-top-80 text_blue_9">Educational Career</div>
          <div class="advisory_body_card_footer_list p-top-24">
            <ng-container *ngFor="let data of panel.education">
              <div class="advisory_body_card_footer_list_item">
                <div class="advisory_body_card_footer_list_item_grid">
                  <div class="p-top-8">
                    <div class="hl_1"></div>
                  </div>
                  <div class="advisory_body_card_footer_list_item_grid_center">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8.5" cy="8.5" r="6" fill="white" stroke="#0032A0" stroke-width="5" />
                    </svg>
                    <div class="height-80 dis-flex-1">
                      <div class="vl_1"></div>
                    </div>
                  </div>
                  <div class="p-top-8">
                    <div class="hl_1"></div>
                  </div>
                </div>
                <div class="advisory_body_card_footer_list_item_box p-top-16 p-x-10">
                  <div class="height-100-per">
                    <div class="bg_1 height-100-per border-radius-20">
                      <div class="dis-flex-1">
                        <!-- This section will hide if data.year or data.month is missing -->
                        <div *ngIf="data.year && data.month"
                          class="advisory_body_card_footer_list_item_box_hexagon m-t-_70 dis-flex-3">
                          <p class="text_blue_10 mb-1" [innerHtml]="data.year"></p>
                          <p class="text_style_1 mb-1">{{ data.month }}</p>
                        </div>
                      </div>
                      <div class="text-center advisory_body_card_footer_list_item_box_bottom dis-flex-3 p-x-20">
                        <p class="text_black_1" [innerHtml]="data.degree"></p>
                        <p class="text_style_11" [innerHtml]="data['degree_description']"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="advisory_body_card_footer_list_item1">
                <div class="advisory_body_card_footer_list_item1_box p-top-16 p-x-10">
                  <div class="p-top-70 height-100-per">
                    <div class="bg_1 height-100-per border-radius-20">
                      <div class="dis-flex-1">
                        <div *ngIf="data.year && data.month"
                          class="advisory_body_card_footer_list_item1_box_hexagon m-t-_70 dis-flex-3">
                          <p class="text_blue_10 mb-1">{{ data.year }}</p>
                          <p class="text_style_1 mb-1">{{ data.month }}</p>
                        </div>
                      </div>
                      <div class="text-center advisory_body_card_footer_list_item1_box_bottom dis-flex-3 p-x-20">
                        <p class="text_black_1" [innerHtml]="data.degree"></p>
                        <p class="text_style_11" [innerHtml]="data['degree_description']"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<app-footer />